import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiZap, FiHome, FiPhone, FiArrowLeft } = FiIcons;

const NotFound = () => {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4" style={{ paddingTop: '80px' }}>
      <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse at 50% 40%, rgba(0,102,255,0.1), transparent 70%)' }} />
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} className="relative text-center max-w-lg">
        <motion.div animate={{ rotate: [0, -10, 10, -10, 0] }} transition={{ duration: 1.5, repeat: Infinity, repeatDelay: 3 }}
          className="w-24 h-24 bg-gradient-to-br from-blue-600 to-cyan-600 rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-2xl shadow-blue-500/30">
          <SafeIcon icon={FiZap} className="text-white text-5xl" />
        </motion.div>
        <h1 className="text-8xl font-black text-white mb-2">404</h1>
        <h2 className="text-2xl font-bold text-gray-300 mb-3">Page Not Found</h2>
        <p className="text-gray-500 mb-8 leading-relaxed">
          Looks like this page lost power! The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-4">
          <Link to="/" className="flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-6 py-3 rounded-2xl font-semibold hover:from-blue-700 hover:to-cyan-700 transition-all">
            <SafeIcon icon={FiHome} /><span>Go Home</span>
          </Link>
          <a href="tel:+919906669918" className="flex items-center space-x-2 border border-gray-700 text-gray-300 px-6 py-3 rounded-2xl font-semibold hover:border-blue-500 hover:text-white transition-all">
            <SafeIcon icon={FiPhone} /><span>Call Us</span>
          </a>
        </div>
        <div className="mt-8 flex items-center justify-center space-x-6 text-sm text-gray-600">
          {['Home','Services','Gallery','Contact'].map(p => (
            <Link key={p} to={`/${p.toLowerCase() === 'home' ? '' : p.toLowerCase()}`}
              className="hover:text-blue-400 transition-colors">{p}</Link>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;
